<div class="py-3 bg-dark text-white">
  <div class="w-100 px-16 my-2 column-container">
    <div class="row-container xs w-100">
      <div class="column-container w-100">
        <div mat-subheader class="py-0 mt-4 mat-body-2" i18n>
          Atención al cliente
        </div>
        <ul class="mt-2 mat-body-1">
          <li *ngFor="let item of columnOneNavLinks" class="py-1">
            <a
              [href]="item.url"
              vakiNewWindow
              i18n="footer | Help Center @@navHelpCenter"
              class="text-white text-decoration-none"
              (click)="
                ga4Service.logClickEvent(ga4ClickEvents.CLICK_FOOTER_BUTTON, {
                  section: 'footer',
                  item_id: item.id
                })
              "
              >{{ currentLanguage === 'en' ? item.nameEN : item.name }}</a
            >
          </li>
        </ul>
      </div>
      <div class="mx-4 column-container w-100">
        <div mat-subheader class="py-0 mt-4 text-light mat-body-2">
          <span i18n>Acerca de nosotros</span>
        </div>
        <ul class="mt-2 mat-body-1">
          <li *ngFor="let item of columnTwoNavLinks" class="py-1">
            <a
              [href]="item.url"
              vakiNewWindow
              class="text-white text-decoration-none"
              (click)="
                ga4Service.logClickEvent(ga4ClickEvents.CLICK_FOOTER_BUTTON, {
                  section: 'footer',
                  item_id: item.id
                })
              "
              >{{ currentLanguage === 'en' ? item.nameEN : item.name }}</a
            >
          </li>
        </ul>
      </div>
      <div class="column-container w-100">
        <div mat-subheader class="py-0 mt-4 text-light mat-body-2">
          <span i18n>Nuestras marcas</span>
        </div>
        <ul
          class="mt-2 mat-body-1 p-0 text-white"
          gdColumns="repeat(2,1fr)"
          gdGap="0 24px"
        >
          <li *ngFor="let item of columnThreeNavLinks" class="py-1">
            <a
              [href]="item.url"
              vakiNewWindow
              class="text-white text-decoration-none"
              (click)="
                ga4Service.logClickEvent(ga4ClickEvents.CLICK_FOOTER_BUTTON, {
                  section: 'footer',
                  item_id: item.id
                })
              "
              >{{ currentLanguage === 'en' ? item.nameEN : item.name }}</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="row-container md w-100">
      <div class="column-container">
        <a routerLink="/" *ngIf="logo">
          <img [src]="logo.src" [alt]="logo.alt" loading="lazy" />
        </a>
        <div class="column-container">
          <div class="my-2 row-container">
            <a
              class="social-icon social-icon--twitter transparent"
              vakiNewWindow
              href="https://twitter.com/VakiGlobal"
              >twitter</a
            >
            <a
              class="social-icon social-icon--facebook transparent"
              vakiNewWindow
              href="https://facebook.com/VakiGlobal"
              >facebook</a
            >
            <a
              class="social-icon social-icon--instagram transparent"
              vakiNewWindow
              href="https://instagram.com/VakiGlobal"
              >instagram</a
            >
            <a
              class="social-icon social-icon--youtube transparent"
              vakiNewWindow
              href="https://youtube.com/VakiGlobal"
              >youtube</a
            >
            <a
              class="social-icon social-icon--linkedin transparent"
              vakiNewWindow
              href="https://linkedin.com/company/VakiGlobal"
              >linkedin</a
            >
          </div>
          <span
            i18n="footer | Copyright Vaki @@copyrightVaki"
            class="mat-caption text-white"
          >
            © {{ currentYear }} Vaki Global, Ltd
          </span>
        </div>
      </div>

      <div class="row-container">
        <div>
          <a
            href="https://www.colombiafintech.co/lineaDeTiempo/empresa/vaki/articulos"
            target="_blank"
          >
            <img
              src="assets/images/logos/logo-colombia-fintech.svg"
              class="logo-partner"
              alt="Logo Colombia Fintech"
              loading="lazy"
            />
          </a>
        </div>
        <div>
          <a href="http://www.afico.org/sello.html" target="_blank">
            <img
              src="assets/images/logos/partners/afico-light.png"
              class="logo-partner"
              alt="Logo AFICO"
              loading="lazy"
            />
          </a>
        </div>
      </div>
      <div class="my-4 row-container">
        <button mat-button [matMenuTriggerFor]="language" color="primary">
          🌐{{ currentLanguage | uppercase }}
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #language="matMenu">
          <button
            mat-menu-item
            *ngFor="let language of languages"
            (click)="languageSelected.emit(language.code)"
            [value]="language"
          >
            <span>{{ language.name }}</span>
          </button>
        </mat-menu>
        <button
          mat-button
          [matMenuTriggerFor]="currency"
          data-cy="currencySelectorButton"
          color="primary"
        >
          💲{{ currentCurrency }}
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #currency="matMenu" data-cy="menuCurrencyOptions">
          <button
            mat-menu-item
            *ngFor="let currency of currencies"
            (click)="currencySelected.emit(currency)"
            [value]="currency"
            [attr.data-cy]="'currencyOption' + currency"
            aria-label="Selecciona moneda ${currency}"
          >
            <span>{{ currency }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
